import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Utysc } from '../entity/Utysc-angular';


@Injectable({
  providedIn: 'root'
})
export class UtyscServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = 'SC001=MAINTABLE,SC002=ITEM';
    this.defaultItem = new Utysc();
    this.entityType.type = EntityType.detail;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      SC001: '主資料表', SC002: '序號', SC003: '使用者代號', SC005: '備註'
    };

    this.fieldNames = 'SC001,SC002,SC003,SC005';
    this.fieldLengths = { SC001: 50, SC002: 50, SC003: 20, SC005: 255 };
    this.columnDefs = [
      { field: "SC001", headerName: "主資料表", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SC002", headerName: "序號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SC003", headerName: "使用者代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "SC004", headerName: "保留", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "SC005", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'UTYSC';
    this.isSys = true;
    this.sqlSelect = `SELECT UTYSC.*  FROM ##UTYSC`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY SC001,SC002,SC003`;
    this.keyFields = ['SC001', 'SC002', 'SC003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['SC001', 'SC002', 'SC003'];
    this.seqField = 'SC002';
    this.seqFieldLength = 50;
  }
  override async validateItem(item: Utysc): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Utysc): Promise<Utysc> {
    await super.newRecord(newItem);
    return newItem;
  }




}

